import React, { useEffect, useState } from "react";
import { Row, Col, Button, Image, Badge } from "react-bootstrap";
import { useSwitchTransition } from "transition-hook";
import * as Icon from "react-bootstrap-icons";
import Modal from "react-bootstrap/Modal";
import Form from 'react-bootstrap/Form';
import Element from '../InputFields/input';
import { FormContext } from '../InputFields/FormContext';
import Scheduler from '../Scheduler/scheduler'
import './workflowModals.css';
import { CustomButton } from "../CustomButtonComponent/button";

export default function IntegrationWorkflowModal(props) {
    // console.log("INTEGRATION WORKFLOW MODAL: ", props)
    // console.log("INTEGRATION WORKFLOW MODAL: ", props)
    const fullModal = props.fullmodal
    const workflowid = props.recommendation.workflow.FlowId
    const formSchema = props.recommendation.workflow.FormSchema.Schema
    const [scheduleCheck, setScheduleCheck] = useState(props.recommendation.workflow.FormSchema.schedule !== null ? true : false)
    const [radioSectionFlag, setRadioSectionFlag] = useState(props.recommendation.workflow.FormSchema.schedule)
    const transition = useSwitchTransition(scheduleCheck, 500)
    const [schedulerSchema, setSchedulerSchema] = useState(JSON.parse(props.recommendation.workflow.Schedule))
    const [fullSchema, setFullSchema] = useState(formSchema)
    const [elements, setElements] = useState(fullSchema);
    const [checkboxId, setCheckboxId] = useState("")
    const [schedulerFormcontext, setSchedulerFormcontext] = useState([])
    const [buttonClickedState, setButtonClickedState] = useState(false)

    const getScheduler = (value) => {
        setSchedulerFormcontext(value)
    }
    // useEffect(() => {
    //     console.log("SCHEMA: ", props.recommendation.workflow)
    //     console.log("SCHEDULER: ", props.recommendation.workflow.Schedule)
    // }, [fullSchema])

    // useEffect(() => {
    //   setRadioSectionFlag(scheduleCheck)
    // }, [scheduleCheck])
    

    const handleSubmit = (event) => {
        if (!buttonClickedState) {
            event.preventDefault();
            props.handleworkflowsave(workflowid, elements, scheduleCheck, schedulerFormcontext)
            setButtonClickedState(!buttonClickedState)
        } else {
            alert("Workflow is being saved, please wait.")
        }
    }
    const handleChange = (field_id, event) => {
        const newElements = [...elements]
        newElements.forEach(field => {
            const { type, id } = field;
            if (field_id === id) {
                switch (type) {
                    case 'checkbox':
                        field['value'] = event.target.checked;
                        break;

                    case 'select':
                        field['value'] = event.value;
                        break;

                    case 'date':
                        field['value'] = event;
                        break;

                    default:
                        field['value'] = event.target.value;
                        break;
                }
            }
            // console.log("NEW ELEMENTS on CHANGE: ", newElements)
            const newFullSchema = [...newElements]
            // console.log("NEW FULL SCHEMA: ", newFullSchema)

            setElements(newFullSchema)
        });
        for (let field_index in newElements) {
            if (newElements[field_index].id == checkboxId) {
                // console.log("CHECKBOXID: ", checkboxId)
                if (newElements[field_index].value == false) {
                    // console.log("CHECKBOX: ", "disabled")
                    newElements.forEach((field, index) => {
                        if (index > field_index) {
                            field["disabled"] = true
                        }
                    });
                } else {
                    // console.log("CHECKBOX: ", "enabled")
                    newElements.forEach((field, index) => {
                        if (index > field_index) {
                            field["disabled"] = false
                        }
                    });
                }
            }
        }
    }
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            centered
            className={fullModal ? "workflow-modal" : "smallmodal"}
        >
            <Modal.Header closeButton className="modal-header-title">
                {
                    fullModal
                        ?
                        <>
                            <h2>{props.recommendation.workflow.FlowName}</h2>
                            <h6>{props.recommendation.workflow.FlowDescription}</h6>
                        </>
                        :
                        <h6>{props.recommendation.workflow.FlowName}</h6>
                }

            </Modal.Header>
            <Modal.Body style={{ maxHeight: 500, overflowY: "auto" }}>
                {
                    fullModal ?
                        <Row className="body-layer">
                            <Col md={3} className="">
                                <Row>
                                    <div className="workflow-modal-logo">
                                        <Image src={props.recommendation.workflow.SourceVendorLogoLink} className="recommended-vendor-logo" rounded />
                                        <div className="workflow-name">
                                            <h6>{props.recommendation.workflow.SourceVendorName}</h6>
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                            <Col md={6}>
                                <Row className="flow-container">
                                    <Row className="flow-wrapper">
                                        <Col md={6} className="tbl rainbow"></Col>
                                    </Row>
                                </Row>
                            </Col>
                            <Col md={3}>
                            <CustomButton
                                progress={props.apiflag}
                                onclick={(e) => handleSubmit(e)}
                                content={props.apiflag ? "Saving" : "Submit"}
                                disable={props.apiflag}
                            />
                            </Col>
                            <Row>
                                <Col md={3}></Col>
                                <Col md={6}>
                                    <Row className="workflow-action-container-wrapper">
                                        <div className="workflow-action-container">
                                            {/* <h4>{props.recommendation.workflow.FlowDescription}</h4> */}
                                            <FormContext.Provider value={{ handleChange }}>
                                                <Form>
                                                    <Row className="no-gutter">
                                                        {
                                                            elements &&
                                                            elements.map((field, i) =>
                                                                <Element
                                                                    key={i}
                                                                    field={field}
                                                                    md={
                                                                        field.type == "text"
                                                                            ?
                                                                            12
                                                                            :
                                                                            (field.type == "checkbox"
                                                                                ?
                                                                                2
                                                                                :
                                                                                12)}
                                                                />)
                                                        }
                                                        {
                                                            radioSectionFlag ?
                                                                <div className="flex-row-center-start" style={{ marginTop: 20, fontWeight: 600 }}>
                                                                    {/* <p>Would you like to schedule this flow? </p> */}
                                                                    {/* <input type="checkbox" 
                                                                    className={"form-check-input move-left custom-check-input"} id="exampleCheck1" 
                                                                    checked={scheduleCheck}
                                                                    onChange={event => setScheduleCheck(event.target.checked)}
                                                                    autoComplete="new-password"
                                                                /> */}
                                                                    <div class="form-check form-check-inline flex-row-center-center">
                                                                        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="schedule" value={scheduleCheck} checked={scheduleCheck} onClick={() => setScheduleCheck(true)} />
                                                                        <label class="form-check-label schedule-check" for="schedule">Schedule</label>
                                                                    </div>
                                                                    <div class="form-check form-check-inline flex-row-center-center">
                                                                        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="ondemand" value={!scheduleCheck} checked={!scheduleCheck} onClick={() => setScheduleCheck(false)} />
                                                                        <label class="form-check-label schedule-check" for="ondemand">On-demand</label>
                                                                    </div>
                                                                </div>
                                                                : <></>
                                                        }
                                                        {transition((state, stage) => (
                                                            <div
                                                                style={{
                                                                    transition: '1s',
                                                                    // position: 'absolute',
                                                                    opacity: stage === 'enter' ? 1 : 0,
                                                                    transformOrigin: 'center bottom',
                                                                    transform: {
                                                                        from: 'translateY(10%)',
                                                                        enter: 'translateY(0%)',
                                                                        leave: 'translateY(-10%)',
                                                                    }[stage],
                                                                }}
                                                            >
                                                                {state ?
                                                                    <Row className="pad-trbl-10">
                                                                        <h5 className="workflow-modal-headings">Schedule</h5>
                                                                        <Scheduler previousschedule={schedulerSchema} getscheduler={getScheduler} />
                                                                    </Row> : <></>}
                                                            </div>
                                                        ))}
                                                        {/* {
                                                            scheduleCheck ?
                                                                <Row className="no-gutter scheduler-wrapper">
                                                                    <h5 className="workflow-modal-headings">Schedule</h5>
                                                                    <Scheduler getscheduler={getScheduler} />
                                                                </Row>
                                                                : <></>
                                                        } */}

                                                    </Row>
                                                    <Row className="workflow-modal-other-info">
                                                        {!props.recommendation.workflow.mappingExist && (
                                                            <h5 style={{ display: "inline-block" }}>
                                                                <Badge
                                                                    bg="warning"
                                                                    text="dark"
                                                                    style={{ marginRight: "10px" }}
                                                                >
                                                                    No mappings connected to the flow
                                                                </Badge>
                                                            </h5>
                                                        )}
                                                        {!props.recommendation.workflow.credentialExist && (
                                                            <h5 style={{ display: "inline-block" }}>
                                                                <Badge bg="danger">
                                                                    {" "}
                                                                    Credentials not found
                                                                </Badge>
                                                            </h5>
                                                        )}
                                                    </Row>
                                                </Form>
                                            </FormContext.Provider>
                                        </div>
                                    </Row>
                                </Col>
                                <Col md={3} className="flex-column-center-end">
                                </Col>
                            </Row>
                            <Col md={3}></Col>
                            <Col md={6}>
                                <Row className="flow-container">
                                    <Row className="flow-wrapper">
                                        <Col md={6} className="ltr rainbow2"></Col>
                                    </Row>
                                </Row>
                            </Col>
                            <Col md={3}>
                                <Row>
                                    <div className="workflow-modal-logo">
                                        <div className="workflow-name">
                                            <h6>{props.recommendation.workflow.TargetVendorName}</h6>
                                        </div>
                                        <Image src={props.recommendation.workflow.TargetVendorLogoLink} className="recommended-vendor-logo" rounded />
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                        :
                        <Row className="workflow-action-container-wrapper">
                            <div className="workflow-action-container-pro">
                                {/* <h4>{props.recommendation.workflow.FlowDescription}</h4> */}
                                <FormContext.Provider value={{ handleChange }}>
                                    <Form>
                                        <Row className="no-gutter">
                                            {
                                                elements &&
                                                elements.map((field, i) =>
                                                    <Element
                                                        key={i}
                                                        field={field}
                                                        md={
                                                            field.type == "text"
                                                                ?
                                                                12
                                                                :
                                                                (field.type == "checkbox"
                                                                    ?
                                                                    2
                                                                    :
                                                                    12)}
                                                    />)
                                            }
                                            {
                                                radioSectionFlag ?
                                                    <div className="flex-row-center-start" style={{ marginTop: 20, fontWeight: 600 }}>
                                                        {/* <p>Would you like to schedule this flow? </p> */}
                                                        {/* <input type="checkbox" 
                                                        className={"form-check-input move-left custom-check-input"} id="exampleCheck1" 
                                                        checked={scheduleCheck}
                                                        onChange={event => setScheduleCheck(event.target.checked)}
                                                        autoComplete="new-password"
                                                    /> */}
                                                        <div class="form-check form-check-inline flex-row-center-center">
                                                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="schedule" value={scheduleCheck} checked={scheduleCheck} onClick={() => setScheduleCheck(true)} />
                                                            <label class="form-check-label schedule-check" for="schedule">Schedule</label>
                                                        </div>
                                                        <div class="form-check form-check-inline flex-row-center-center">
                                                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="ondemand" value={!scheduleCheck} checked={!scheduleCheck} onClick={() => setScheduleCheck(false)} />
                                                            <label class="form-check-label schedule-check" for="ondemand">On-demand</label>
                                                        </div>
                                                    </div>
                                                    : <></>
                                            }
                                            {transition((state, stage) => (
                                                <div
                                                    style={{
                                                        transition: '1s',
                                                        // position: 'absolute',
                                                        opacity: stage === 'enter' ? 1 : 0,
                                                        transformOrigin: 'center bottom',
                                                        transform: {
                                                            from: 'translateY(10%)',
                                                            enter: 'translateY(0%)',
                                                            leave: 'translateY(-10%)',
                                                        }[stage],
                                                    }}
                                                >
                                                    {state ?
                                                        <Row className="pad-trbl-10">
                                                            <h5 className="workflow-modal-headings">Schedule</h5>
                                                            <Scheduler previousschedule={schedulerSchema} getscheduler={getScheduler} />
                                                        </Row> : <></>}
                                                </div>
                                            ))}
                                            {/* {
                                                scheduleCheck ?
                                                    <Row className="pad-trbl-10">
                                                        <h5 className="workflow-modal-headings">Schedule</h5>
                                                        <Scheduler getscheduler={getScheduler} />
                                                    </Row>
                                                    : <></>
                                            } */}
                                        </Row>
                                        <Row className="workflow-modal-other-info">
                                            <Col xs={8}>
                                                {!props.recommendation.workflow.mappingExist && (
                                                    <h5 style={{ display: "inline-block" }}>
                                                        <Badge
                                                            bg="warning"
                                                            text="dark"
                                                            style={{ marginRight: "10px" }}
                                                        >
                                                            No mappings connected to the flow
                                                        </Badge>
                                                    </h5>
                                                )}
                                                {!props.recommendation.workflow.credentialExist && (
                                                    <h5 style={{ display: "inline-block" }}>
                                                        <Badge bg="danger">
                                                            {" "}
                                                            Credentials not found
                                                        </Badge>
                                                    </h5>
                                                )}
                                            </Col>
                                            <Col md={4}>
                                            <CustomButton
                                                progress={props.apiflag}
                                                onclick={(e) => handleSubmit(e)}
                                                content={props.apiflag ? "Saving" : "Submit"}
                                                disable={props.apiflag}
                                            />
                                            </Col>
                                        </Row>
                                    </Form>
                                </FormContext.Provider>
                            </div>
                        </Row>
                }
            </Modal.Body>
            <Modal.Footer className="workflow-footer">
            </Modal.Footer>
        </Modal>
    );
}